import * as React from "react";
import KnowladgeColorTheory from "../containers/KnowladgeColorTheory";

export default (props) => <KnowladgeColorTheory {...props} />;
